
class ProductApiKey {
	key = null;
	addedOnUsdfDate = null;
}


export { ProductApiKey };
